export default __webpack_public_path__ + "static/InfoSection3-577989dc00502373d1ff0311f81f82a4.png";